<!-- 总评center地图 -->
<style lang="stylus" scoped>
.map-wrap {
  // position: relative;
  display: flex;
}

.map-type-wrap {
  position: absolute;
  bottom: 40px;
  left: 50px;
}

.map-type {
  margin-bottom: 20px;
  color: #77CAD8;
  font-size: 10px;
  text-align: center;

  img {
    width: 100%;
    height: 100%;
  }

  div {
    width: 52px;
    height: 33px;
    margin-bottom: 10px;
    border: 1px solid rgba(14, 202, 247, 1);
    border-radius: 4px;
  }
}

.changeType {
  margin-left: 20px;
  margin-top: 450px;
  color: #77CAD8;
  font-size: 10px;
  text-align: center;

  .nav-item {
    margin-bottom: 20px;
  }
}
.map {
  width: 655px;
  height: 630px;
  margin: 0 auto;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="map-wrap">
    <!-- <div class="changeType">
      <div class="nav-item" @click="clickSatellite">
        <img src="static/img/dashboard/map-type-2.png" alt>
        <p>卫星地图</p>
      </div>
      <div class="nav-item" @click="clickNormal">
        <img src="static/img/dashboard/map-type-1.png" alt>
        <p>平面图</p>
      </div>
    </div> -->
    <div class="map" @click="jumpChild">
      <mapChart v-if="!ifSatellite"></mapChart>
      <satelliteMap v-else></satelliteMap>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'
import satelliteMap from '../satelliteMap'
import mapChart from '../mapChart'

export default {
  props: {
    areaName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myChart: {},
      ifSatellite: false
    }
  },
  components: {
    satelliteMap,
    mapChart
  },
  methods: {
    jumpChild() {
      this.$router.push('/base');
    },
    clickSatellite() {
      this.ifSatellite = true
    },
    clickNormal() {
      this.ifSatellite = false
    }
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?52473a76